import classNames from 'classnames'
import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text'
import sc from '../common.scss'
import {PriceProps} from './interfaces'
import s from './price.scss'

export const Price = ({value, label, dataHook = null}: PriceProps) => {
  if (!value) {
    return null
  }

  return (
    <div className={classNames(sc.splitRow, s.subtotalRow)} data-hook={dataHook}>
      <EventText>{label}</EventText>
      <EventText>{value}</EventText>
    </div>
  )
}
